module.exports = __webpack_public_path__ + "static/img/icon8.fd966149.svg";